import { Link, List, ListItem, ListItemText, Stack } from '@mui/material';

import { Text, Title } from 'common';

import styles from './index.module.css';

export function TermsOfUse() {
  return (
    <div className={styles.Terms}>
      <div className={styles.TermsWrapper}>
        <Stack alignItems="center">
          <Title component="h1" variant="heading4">
            NOTABLE PLATFORM
          </Title>
          <Title component="h1" variant="heading4">
            STAFF AND PROVIDER END USER TERMS OF USE
          </Title>
        </Stack>
        <Text variant="body2" align="justify">
          <Text variant="body2" bold component="span">
            Last Updated:
          </Text>
          <Text variant="body2" component="span">
            &nbsp;December 11, 2025
          </Text>
        </Text>
        <Text variant="body2" align="justify">
          <Text variant="body2" bold component="span">
            IMPORTANT: PLEASE READ THESE TERMS CAREFULLY BEFORE USING THE NOTABLE PLATFORM.
          </Text>
        </Text>
        <Text variant="body2" align="justify">
          <Text variant="body2" component="span">
            These Terms of Use (the &quot;
          </Text>
          <Text variant="body2" bold component="span">
            Terms
          </Text>
          <Text variant="body2" component="span">
            &quot;) are a legally binding contract between the user (&quot;
          </Text>
          <Text variant="body2" bold component="span">
            you
          </Text>
          <Text variant="body2" component="span">
            &quot;) and Zealth, Inc., DBA Notable, (&quot;
          </Text>
          <Text variant="body2" bold component="span">
            Notable
          </Text>
          <Text variant="body2" component="span">
            ,&quot; &quot;
          </Text>
          <Text variant="body2" bold component="span">
            we
          </Text>
          <Text variant="body2" component="span">
            ,&quot; or &quot;
          </Text>
          <Text variant="body2" bold component="span">
            us
          </Text>
          <Text variant="body2" component="span">
            &quot;). Notable provides the Services (as defined below) to you subject to these Terms,
            which may be updated by Notable from time to time without prior notice to you. These
            Terms govern the use of the Services by providers, staff, suppliers, and other entities
            in the health care industry, including, but not limited to, physicians, chiropractors,
            dentists, optometrists, psychologists, physical and occupational therapists, holistic
            care providers, nurses, physicians&rsquo; assistants, administrative personnel,
            pharmacies, hospitals, and other appropriate health care providers (each a &ldquo;
          </Text>
          <Text variant="body2" bold component="span">
            Healthcare Professional
          </Text>
          <Text variant="body2" component="span">
            &rdquo;) who utilize the Platform.
          </Text>
        </Text>
        <Text variant="body2" align="justify">
          <Text variant="body2" component="span">
            Your access and use of the Services is also governed the Enterprise Terms and any
            exhibits, addenda, and attachments thereto (collectively the &ldquo;
          </Text>
          <Text variant="body2" bold component="span">
            Enterprise Terms
          </Text>
          <Text variant="body2" component="span">
            &rdquo;) between Notable and the organization that has contracted for your access to and
            use of the Services (each a &ldquo;
          </Text>
          <Text variant="body2" bold component="span">
            Notable Client
          </Text>
          <Text variant="body2" component="span">
            &rdquo;). If you are accessing the Platform as part of a demonstration or trial, the
            Enterprise Terms shall be the most current version available at{' '}
            <Link href="https://www.notablehealth.com/enterprise-terms">
              https://www.notablehealth.com/enterprise-terms
            </Link>
          </Text>
          <Text variant="body2" component="span">
            , and the Platform is provided to you as a Beta Service defined in Section 2.11 (Trials
            and Betas) thereunder. To the extent that these Terms are in conflict or inconsistent
            with the Enterprise Terms, the Enterprise Terms shall take precedence unless otherwise
            stated to the contrary herein or in the Enterprise Terms. Any capitalized terms not
            defined herein shall have the meaning set forth in the Enterprise Terms. Supplemental
            terms of use or documents that may be posted on or provided through the Platform from
            time to time are hereby expressly incorporated herein by reference. We reserve the
            right, in our sole discretion, to make changes, modifications, or updates to these Terms
            at any time and for any reason. We will alert you about any changes by updating the
            &ldquo;Last updated&rdquo; date of these Terms and you waive any right to receive
            specific notice of each such change. It is your responsibility to periodically review
            these Terms to stay informed of updates. You will be subject to and will be deemed to
            have been made aware of and to have accepted, the changes in any revised Terms by your
            continued use of the Site and/or Platform after the date such revised Terms are posted.
            Unless explicitly stated otherwise, any new features that augment or enhance the current
            Platform, including the release of new Notable properties, shall be subject to these
            Terms.
          </Text>
        </Text>
        <Text variant="body2" align="justify" paddingY={1}>
          <Text variant="body2" component="span">
            BY ACCESSING AND USING THE NOTABLE PLATFORM IN ANY WAY, OR BY CLICKING TO ACCEPT OR
            AGREE TO THESE TERMS WHEN THIS OPTION IS MADE AVAILABLE TO YOU, YOU AGREE TO BE BOUND BY
            THESE TERMS, INCLUDING THE WARRANTY DISCLAIMERS, LIMITATIONS OF LIABILITY, AND
            TERMINATION PROVISIONS BELOW. IF YOU DO NOT AGREE TO THE TERMS, DO NOT USE THE SERVICES
            OR THE NOTABLE PLATFORM.
          </Text>
        </Text>
        <List sx={{ listStyle: 'decimal', pl: 0, listStylePosition: 'inside' }} component="ol">
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  DESCRIPTION OF THE SERVICES.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable provides a platform, including but not limited to the www.notablehealth.com
                website (the &ldquo;
              </Text>
              <Text variant="body2" bold component="span">
                Site
              </Text>
              <Text variant="body2" component="span">
                &rdquo;), a patient-facing web application, mobile applications, services, and other
                technology offerings (collectively, the &ldquo;
              </Text>
              <Text variant="body2" bold component="span">
                Platform
              </Text>
              <Text variant="body2" component="span">
                &rdquo;), which use proprietary automatic intelligence and robotic process
                automation technology to automate and streamline administrative and clinical tasks
                along the care continuum (collectively, the &quot;
              </Text>
              <Text variant="body2" bold component="span">
                Services
              </Text>
              <Text variant="body2" component="span">
                &quot;). The specific features of the Services that are available may change from
                time to time, and Notable may choose to discontinue some or all of the Services, in
                its sole discretion.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You understand and agree that the Services may include certain communications from
                Notable, such as service announcements and administrative messages. You consent to
                receive such communications from us electronically. Unless explicitly stated
                otherwise, any new features that augment or enhance the current Services shall be
                subject to these Terms.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                The Platform includes or may include information, data, text, messages, software,
                audio, video, photographs, graphics, images, tags, and/or other materials (&quot;
              </Text>
              <Text variant="body2" bold component="span">
                Content
              </Text>
              <Text variant="body2" component="span">
                &quot;). You acknowledge and agree that the Content available through the Platform
                may be obtained or derived from third-party sources (collectively, &quot;
              </Text>
              <Text variant="body2" bold component="span">
                Content Providers
              </Text>
              <Text variant="body2" component="span">
                &quot;), such as individuals or entities that have created and contributed such
                Content to the Platform. Content may also include materials that the Notable Client
                decides to make available to you via the Platform. Your use of any Content,
                including, without limitation any medical information, is at your own risk, as
                described in more detail below.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You acknowledge and agree that your provision of any healthcare services to your
                patients creates a legal and direct business relationship between you and the
                patients, to which Notable is not a party. Notable is not responsible or liable for
                actions or inactions of a patient in relation to your healthcare services. You shall
                have the sole responsibility for any obligations or liabilities to a patient or
                other third parties that arise from your provision of healthcare services. You
                acknowledge and agree that you are solely responsible for taking such precautions as
                may be reasonable and proper (including maintaining adequate insurance that meets
                the requirements of all applicable laws) regarding any acts or omissions of a
                patient or third party.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You are solely responsible (and Notable disclaims all liability related thereto) for
                providing and collecting all informed consent forms and authorizations necessary to
                provide the healthcare services provided by you to patients. You understand that it
                is your responsibility and obligation under state law to provide specific
                information to a patient or a separate informed consent for the patient to sign in
                connection with any healthcare services that you may provide. To avoid any doubt, in
                order to use the Services from Notable, we require that you obtain all required
                informed consent forms required by law from patients. If you do not or cannot
                collect such informed consent forms applicable to patients, you are not permitted to
                use the Services.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  CONDITIONS ON ACCESS TO THE SERVICES.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                We reserve the right to withdraw or amend the Platform, and any service or material
                we provide on the Platform, in our sole discretion without notice. From time to
                time, we may restrict access to some parts of the Platform, or the entire Platform,
                to users, including registered users.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Access to and use of the Platform is limited to Healthcare Professionals who are
                United States residents and at least 18 years of age. Unless otherwise indicated by
                Notable, you must register to use the Platform. To register, you must provide
                Notable with your name, valid email and/or other information specified in the
                registration form (&quot;
              </Text>
              <Text variant="body2" bold component="span">
                Registration Data
              </Text>
              <Text variant="body2" component="span">
                &quot;). By registering, and in consideration of the use of the Platform, you
                represent and warrant that: (i) the Registration Data that you provide about
                yourself is true, accurate, current, and complete; (ii) you are a Healthcare
                Professional; (iii) you are at least 18 years of age; and (iv) you will maintain and
                promptly update the Registration Data to keep it true, accurate, current, and
                complete. You authorize Notable to confirm the truthfulness and accuracy of the
                Registration Data. If you provide any information that is untrue, inaccurate, not
                current, or incomplete, or if Notable has reasonable grounds to suspect that such
                information is untrue, inaccurate, not current, or incomplete, Notable has the right
                to suspend or terminate your account and refuse any and all current or future use of
                the Platform.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You acknowledge and agree that your use of the Platform is dependent upon access to
                telecommunications and Internet services. You further understand that your use of
                the Services may involve or require the transmission of significant amounts of data.
                You understand and agree that you are solely responsible for acquiring and
                maintaining all telecommunications and Internet services and other hardware and
                software required to access and use the Services, including, without limitation, any
                and all costs, fees, expenses and taxes of any kind related to the foregoing or that
                may otherwise arise from your use of the Services. Notable shall not be responsible
                for any loss or corruption of data, lost communications, loss of functionality or
                any other loss or damage of any kind arising from any such telecommunications and
                Internet services. WITHOUT LIMITING THE FOREGOING, YOU ACKNOWLEDGE THAT YOUR USE OF
                THE SERVICES MAY REQUIRE AN APPROPRIATE MOBILE DEVICE AND DATA PLAN, AND THE
                PURCHASE AND MAINTENANCE OF SUCH DEVICE AND PLAN AND ASSOCIATED CHARGES ARE YOUR
                RESPONSIBILITY (AND NOT NOTABLE&rsquo;S).
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Use of the Platform is void where prohibited. By using and/or viewing the Platform,
                you represent and warrant that you have the right, authority, and capacity to agree
                to and abide by these Terms and that you are not prohibited by law from using the
                Services.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  NOT MEDICAL ADVICE; DISCLAIMERS.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable does not provide medical advice and does not make diagnostic, treatment, or
                other clinical decisions or judgments. The Platform and Content are not a substitute
                for the competent analysis and professional judgment of health care professionals.
                The medical information that is provided by you or to you through the Platform is
                dependent upon the Content that you access and the information that you select and
                enter, as well the specifics of your situation. NEITHER NOTABLE NOR ANY CONTENT
                PROVIDER WARRANTS OR GUARANTEES THAT THE MEDICAL INFORMATION OR ANY RESULTS OBTAINED
                THROUGH THE SERVICES WILL BE ACCURATE, RELEVANT, OR UP TO DATE. YOU, AND NOT
                NOTABLE, ARE SOLELY RESPONSIBLE FOR VERIFYING THE ACCURACY OF ALL MEDICAL
                INFORMATION, FOR MAKING DIAGNOSTIC AND CLINICAL DECISIONS, AND FOR COMPLYING WITH
                ALL LAWS, REGULATIONS, LICENSING REQUIREMENTS, AND THE APPLICABLE STANDARD OF CARE
                IN DELIVERING HEALTH CARE SERVICES.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                By accessing the Platform, you assume full responsibility for the use of any
                information obtained through the Platform and agree that neither Notable nor any of
                its licensors or Content Providers is responsible or liable for any claim, loss, or
                damage arising from the use of the information. Your reliance upon the Content
                obtained or used by you through the Platform is solely at your own risk.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  NOTABLE&#39;S PROPRIETARY RIGHTS.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                The Content is protected by applicable intellectual property and other laws,
                including patent, trademark, and copyright laws. All Content and all intellectual
                property in the Content belongs to and is the property of Notable or its licensors.
                Without limiting the preceding sentence, we own and retain all intellectual property
                rights in the features, and functionality (including but not limited to all
                information, software, text, displays, images, video, and audio, and the design,
                selection, and arrangement thereof) contained in the individual pages, components of
                pages, and any collective works contained within the Platform. The Content may not
                be copied, reproduced, modified, published, uploaded, posted, transmitted,
                performed, or distributed in any way, and you agree not to modify, rent, lease,
                loan, sell, distribute, transmit, broadcast, or create derivative works based on the
                Content or the Services, in whole or in part, by any means, except as expressly
                authorized in writing by Notable or the Content Provider, as applicable. Notable and
                the Notable logos are trademarks and the property of Notable. The appearance,
                layout, color scheme, and design of the Platform are protected trade dress. All
                other names and trademarks are the property of their respective holders.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  LIMITED USE LICENSE.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable grants you a non-transferable and non-exclusive right and license to access
                and use the Platform solely for your use as authorized by the Notable Client, and
                subject to the condition that you do not (and do not allow any third party to) (a)
                copy, modify, create a derivative work from the Platform or the Content, and (b)
                reverse engineer, reverse assemble or otherwise attempt to discover any source code.
                You agree not to modify the Platform in any manner or form, nor to use modified
                versions of the Platform or software, including (without limitation) for the purpose
                of obtaining unauthorized access to the Platform. You agree not to access the
                Platform by any means other than through the interface(s) provided by Notable for
                use in accessing the Platform. You agree that you shall not develop, sell, license,
                or distribute applications that launch, are launched from, or are otherwise
                integrated with the Platform without the prior express written consent of Notable.
                You agree that you will not rent, lease, loan, resell for profit, distribute,
                sublicense or use in a time-sharing arrangement the Platform, in whole or in part.
                Any unauthorized use of the Content or Platform may violate patent, copyright,
                trademark, and other laws. You agree to cooperate with Notable to prevent any
                unauthorized copying of the Platform or Content.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  TERMINATION.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Your use of the Platform is subject to and expressly conditioned on your compliance
                with these Terms. We may terminate and/or suspend your access to any portion of the
                Platform upon notice to the Notable Client in the event that we reasonably determine
                that you have violated the Terms. Your access to the Platform may also be terminated
                by the Notable Client.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Upon termination, you shall immediately destroy any Content in your possession, if
                any, and cease use of the Services. Sections 3, 4, 5, 6 and 8 through 22 shall
                survive termination of these Terms for any reason.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  SECURITY.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                The Platform is designed to require users to provide a valid, working email address
                and password to access and use the Platform. Upon registering, you will receive a
                password, which you may change from time to time. Certain other Content, features,
                or functionalities within the Platform may require additional access codes. Your
                email address and the password and codes assigned to you are defined, collectively,
                as your &quot;
              </Text>
              <Text variant="body2" bold component="span">
                Credentials
              </Text>
              <Text variant="body2" component="span">
                &quot;.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You are solely responsible for (1) maintaining the strict confidentiality of your
                Credentials, (2) not allowing another person to use your Credentials to access the
                Services, (3) any and all damages or losses that may be incurred or suffered as a
                result of any activities that occur under your Credentials. You agree to immediately
                notify Notable in writing of any unauthorized use of your Credentials or any other
                breach of security, and to ensure that you sign out from your account at the end of
                each session. You agree to notify us immediately of any unauthorized access to or
                use of your username or password or any other breach of security. You also agree to
                ensure that you exit from your account at the end of each session. You should use
                particular caution when accessing your account from a public or shared computer so
                that others are not able to view or record your password or other personal
                information.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable is not and shall not be liable for any harm arising from or relating to the
                theft of your Credentials, your disclosure of your Credentials, or the use of your
                Credentials by another person or entity.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Any attempt to obtain unauthorized access or to exceed authorized access to the
                Services shall be considered a trespass and computer fraud and abuse, punishable
                under state and federal laws. Notable hereby notifies you that any or all
                communications with the Platform can and will be monitored, captured, recorded, and
                transmitted to the authorities as deemed necessary by Notable in its sole discretion
                and without further notice.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  USER-SUBMITTED CONTENT; FEEDBACK.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <List sx={{ listStyle: 'lower-alpha', pl: 4 }} component="ol">
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <ListItemText
                  disableTypography
                  primary={
                    <Text
                      variant="body2"
                      sx={{
                        textDecoration: 'underline',
                        verticalAlign: 'baseline',
                        textDecorationSkipInk: 'none',
                      }}
                      component="span"
                    >
                      Submissions
                    </Text>
                  }
                  sx={{ display: 'inline-block', marginY: 0 }}
                />
                <Text variant="body2" align="justify" display="inline">
                  <Text variant="body2" component="span">
                    . The Platform may permit you to submit information and Content (including data,
                    images, sounds, text, and other things embodied therein) or provide ideas,
                    suggestions, and proposals (collectively, &quot;
                  </Text>
                  <Text variant="body2" bold component="span">
                    Submissions
                  </Text>
                  <Text variant="body2" component="span">
                    &quot;). Notable and its designees shall have the right (but not the obligation)
                    in their sole discretion to pre-screen, refuse, or remove any Submissions or
                    Content that is available via the Platform. Without limiting the foregoing,
                    Notable and its designees shall have the right to remove any Content that
                    violates these Terms or is otherwise objectionable, in Notable&#39;s reasonable
                    and sole discretion.
                  </Text>
                </Text>
                <Text variant="body2" align="justify">
                  <Text variant="body2" component="span">
                    By making a Submission to the Platform, you hereby grant to Notable, our
                    affiliates and service providers, and each of their and our respective
                    licensees, successors, and assigns the right to collect, store, use, reproduce,
                    distribute, modify, publish and prepare derivative works from the Submissions
                    for purposes allowed under the Enterprise Terms, these Terms and applicable law.
                    You represent and warrant that: (i) you own or control all rights in and to your
                    Submissions and have the right to grant the license granted above to us and our
                    affiliates and service providers, and each of their and our respective
                    licensees, successors, and assigns; and (ii) all of your Submissions do and will
                    comply with these Terms. You understand and acknowledge that you are responsible
                    for any Submissions you submit or contribute, and you, not Notable, have full
                    responsibility for such Submissions, including its legality, reliability,
                    accuracy, and appropriateness. You acknowledge and agree that you are solely
                    responsible for all content, data, and information submitted under your account
                    Credentials to the Services or Website, including, without limitation, content,
                    data, and information relating to third parties. We are not responsible or
                    liable to any third party for the content or accuracy of any Submissions posted
                    by you or any other user of the Website.
                  </Text>
                </Text>
                <Text variant="body2" align="justify">
                  <Text variant="body2" component="span">
                    You acknowledge and agree that Notable may collect, analyze and use anonymized
                    or aggregated data regarding the usage and performance of the Platform,
                    including data derived from protected health information (&ldquo;
                  </Text>
                  <Text variant="body2" bold component="span">
                    PHI
                  </Text>
                  <Text variant="body2" component="span">
                    &rdquo;), and create aggregate data that is: (a) not identifiable to any person
                    and, to the extent derived from protected health information, complies with 45
                    C.F.R. &sect; 164.514(b), and (b) is not distributed or otherwise conveyed in a
                    context that identifies you or your patients (&ldquo;De-identified Data&rdquo;).
                    Unless otherwise set forth in the Enterprise Terms or the applicable Business
                    Associate Agreement, Notable may retain and use the De-identified Data without
                    restriction for any purpose, including, but not limited to, operating,
                    analyzing, improving, or marketing the Platform and any related products and
                    services. You further agree that Notable may collect, use, store and transmit
                    technical related information based on your use of the Platform, including
                    information that may identify your computer (such as the Internet Protocol
                    address) (&ldquo;
                  </Text>
                  <Text variant="body2" bold component="span">
                    Analytics Data
                  </Text>
                  <Text variant="body2" component="span">
                    &rdquo;). Notable owns and may use all Analytics Data at its sole discretion.
                  </Text>
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <ListItemText
                  disableTypography
                  primary={
                    <Text
                      variant="body2"
                      sx={{
                        textDecoration: 'underline',
                        verticalAlign: 'baseline',
                        textDecorationSkipInk: 'none',
                      }}
                      component="span"
                    >
                      Feedback
                    </Text>
                  }
                  sx={{ display: 'inline-block', marginY: 0 }}
                />
                <Text variant="body2" align="justify" display="inline">
                  <Text variant="body2" component="span">
                    . In the event you decide to provide any feedback, recommendations and/or
                    suggestions with respect to the Platform (collectively, &ldquo;
                  </Text>
                  <Text variant="body2" bold component="span">
                    Feedback
                  </Text>
                  <Text variant="body2" component="span">
                    &rdquo;), you hereby assign and agree to assign to Notable all of your title,
                    right and interest, including all associated intellectual property rights, in
                    and to the Feedback.
                  </Text>
                </Text>
              </ListItem>
            </List>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  USER CONDUCT.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You agree that you shall not in connection with your use of the Platform to:
              </Text>
            </Text>
            <List sx={{ listStyle: 'lower-alpha', pl: 4 }} component="ol">
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  upload, post, email, transmit or otherwise make available any Submissions that is
                  unlawful, harmful, threatening, abusive, harassing, tortuous, defamatory, vulgar,
                  obscene, libelous, invasive of another&#39;s privacy, hateful, or racially,
                  ethnically or otherwise objectionable;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  harm minors in any way;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  impersonate any person or entity, or falsely state or otherwise misrepresent your
                  affiliation with a person or entity;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  upload, post, email, transmit or otherwise make available any Submissions that you
                  do not have a right to make available under any law or under contractual or
                  fiduciary relationships;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  upload, post, email, transmit or otherwise make available any Submissions that
                  infringes any patent, trademark, trade secret, copyright or other proprietary
                  rights of any party;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  upload, post, email, transmit or otherwise make available any unsolicited or
                  unauthorized advertising, promotional materials, &quot;junk mail,&quot;
                  &quot;spam,&quot; &quot;chain letters,&quot; &quot;pyramid schemes,&quot; or any
                  other form of solicitation, except in those areas that may be designated for such
                  purpose;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  upload, post, email, transmit or otherwise make available any material that
                  contains software viruses or any other computer code, files or programs designed
                  to interrupt, destroy or limit the functionality of any computer software or
                  hardware or telecommunications equipment;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  interfere with or disrupt the Platform or servers or networks connected to the
                  Platform, or disobey any requirements, procedures, policies or regulations of
                  networks connected to the Platform, including using any device, software or
                  routine to bypass robot exclusion headers;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  distribute, collect, transmit PHI and/or personally identifiable information in
                  violation of any applicable laws, regulations, or policies; and/or
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <Text variant="body2" component="span">
                  otherwise violate any applicable local, state, national or international law or
                  any regulations having the force of law.
                </Text>
              </ListItem>
            </List>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You acknowledge, consent and agree that Notable may access, preserve and disclose
                your Registration Data, Submissions, user profile, and other Content if required to
                do so by law or in a good faith belief that such access, preservation, or disclosure
                is reasonably necessary to: (i) comply with legal process; (ii) enforce these Terms;
                (iii) respond to claims that any Content violates the rights of third parties; (iv)
                respond to your requests for customer service; or (v) protect the rights, property
                or personal safety of Notable, its users, and the public.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  PATIENT INFORMATION AND LEGAL COMPLIANCE.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                State and Federal laws, as well as ethical and licensure requirements of your
                profession may impose obligations with respect to patient confidentiality that may
                limit the ability of physicians, health care providers, and persons acting on their
                behalf, to make use of certain patient information (&quot;
              </Text>
              <Text variant="body2" bold component="span">
                Patient Information
              </Text>
              <Text variant="body2" component="span">
                &quot;) and/or to transmit Patient Information to third parties.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You represent and warrant that you will, at all times, comply with all laws directly
                or indirectly applicable to you that may now or hereafter govern the gathering, use,
                transmission, processing, receipt, reporting, disclosure, maintenance, and storage
                of the Patient Information, and use your best efforts to cause all persons or
                entities under your direction or control to comply with such laws. You are at all
                times solely responsible for obtaining and maintaining all patient consents, if
                applicable, and all other legally necessary consents or permissions required or
                advisable to disclose, process, retrieve, transmit, and view the Patient Information
                that you transmit, store, or receive in connection with the Platform and any
                third-party site.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                WE CANNOT AND DO NOT ASSUME ANY RESPONSIBILITY FOR YOUR USE OR MISUSE OF PATIENT
                INFORMATION OR OTHER INFORMATION TRANSMITTED, MONITORED, STORED OR RECEIVED WHILE
                USING THE NOTABLE PLATFORM. SUBJECT TO APPLICABLE LAW, WE RESERVE THE RIGHT TO AMEND
                OR DELETE ANY CONTENT (ALONG WITH THE RIGHT TO REVOKE OR RESTRICT ACCESS TO THE
                SERVICES) THAT IN OUR SOLE DISCRETION VIOLATES THE ABOVE.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Your representations, warranties, and obligations in this section survive
                termination of these Terms.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  FLOW STUDIO TERMS.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />
            <Text variant="subtitle2" align="justify" marginTop={-0.75}>
              <Text variant="subtitle2" component="span">
                The following terms apply to your use of Flow Studio including Flow Builder.
              </Text>
            </Text>
            <List sx={{ listStyle: 'lower-alpha', pl: 4 }} component="ol">
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <ListItemText
                  disableTypography
                  primary={
                    <Text
                      variant="body2"
                      sx={{
                        textDecoration: 'underline',
                        verticalAlign: 'baseline',
                        textDecorationSkipInk: 'none',
                      }}
                      component="span"
                    >
                      Your Responsibilities
                    </Text>
                  }
                  sx={{ display: 'inline-block', marginY: 0 }}
                />

                <Text variant="body2" component="span">
                  . Flow Studio is a no-code interface for building, configuring, deploying, and
                  monitoring custom automations for clinical and patient experience use cases (each
                  a &ldquo;
                </Text>
                <Text variant="body2" bold component="span">
                  Customer Flow
                </Text>
                <Text variant="body2" component="span">
                  &rdquo;). You shall be solely responsible for your Customer Flows You represents
                  and warrants that: (a) all Customer Flows will be created in compliance with these
                  Terms (b) you or the Notable Client has sufficient rights for any data or data
                  source connected a Customer Flow, and (b) you or the Notable Client have
                  sufficient consents required to perform a particular Customer Flow (e.g. patient
                  communication consents, etc.).&nbsp;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <ListItemText
                  disableTypography
                  primary={
                    <Text
                      variant="body2"
                      sx={{
                        textDecoration: 'underline',
                        verticalAlign: 'baseline',
                        textDecorationSkipInk: 'none',
                      }}
                      component="span"
                    >
                      Release of Liability and Indemnity
                    </Text>
                  }
                  sx={{ display: 'inline-block', marginY: 0 }}
                />

                <Text variant="body2" component="span">
                  . Notable shall have no liability for, and you shall indemnify, defend, and hold
                  Notable harmless against any claim related to, any Customer Flows or use thereof,
                  including, without limitation, for any alleged or actual infringement on rights of
                  any third party, any reliance on Customer Flow outputs, disruption of operations,
                  or other effects directly or proximately caused by deploying or modifying a
                  Customer Flow.&nbsp;
                </Text>
              </ListItem>
              <ListItem
                sx={{
                  display: 'list-item',
                  textAlign: 'justify',
                  lineHeight: (theme) => theme.typography.body2.lineHeight,
                  paddingY: 0,
                }}
              >
                <ListItemText
                  disableTypography
                  primary={
                    <Text
                      variant="body2"
                      sx={{
                        textDecoration: 'underline',
                        verticalAlign: 'baseline',
                        textDecorationSkipInk: 'none',
                      }}
                      component="span"
                    >
                      Independent Development and Residuals
                    </Text>
                  }
                  sx={{ display: 'inline-block', marginY: 0 }}
                />

                <Text variant="body2" component="span">
                  . These Flow Studio Terms shall not limit or restrict Notable&rsquo;s right to (i)
                  create derivative works using a Customer Flow, or develop, or have developed,
                  components that may be similar to, or may perform similar functions to, any
                  Customer Flow; and (ii) use any general information, ideas, concepts, know-how,
                  processes, techniques, programming routines and subroutines, methodologies,
                  processes, skills, or expertise embodied in any Flow. These Flow Studio Terms will
                  not be construed as a representation or inference that each Party will not develop
                  or acquire products, for itself or others, that compete with the products,
                  systems, or methods contemplated by the other Party&rsquo;s Confidential
                  Information, provided that the Party has not done so in breach of the Agreement.
                </Text>
              </ListItem>
            </List>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  DEMONSTRATION AND TRIAL USE.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                If you are accessing the Platform as part of a demonstration or trial,
              </Text>
              <Text variant="body2" component="span">
                &nbsp;the Platform is provided to you solely as a Beta Service, and may only be used
                for internal evaluation during the period designated by Notable. We may terminate
                your access at any time for any reason. You are solely responsible for your acts
                and/or omissions, including without limitation payment of any third-party charges
                which may be incurred by the use of connected third-party services. Notwithstanding
                anything else in these Terms or the Enterprise Terms, Beta Services are offered
                &ldquo;AS-IS&rdquo;, without warranties, indemnities, or guarantees.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  DISCLAIMER OF WARRANTIES.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                EXCEPT AS EXPRESSLY PROVIDED HEREIN, NOTABLE DISCLAIMS ALL WARRANTIES WITH RESPECT
                TO THE NOTABLE PLATFORM, WHETHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION
                ANY IMPLIED WARRANTY OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
                NONINFRINGEMENT. EACH PARTY WILL BE SOLELY AND INDIVIDUALLY RESPONSIBLE TO COMPLY
                WITH ALL LAWS AND REGULATIONS RELATING TO ITS RESPECTIVE BUSINESS OPERATIONS.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  LIMITATION OF LIABILITY.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                YOU EXPRESSLY UNDERSTAND AND AGREE THAT UNDER NO CIRCUMSTANCES SHALL NOTABLE, ITS
                LICENSORS OR CONTENT PROVIDERS BE LIABLE TO ANY USER ON ACCOUNT OF THAT USER&#39;S
                USE OR MISUSE OR RELIANCE ON THE NOTABLE PLATFORM. THIS LIMITATION OF LIABILITY
                SHALL APPLY TO PREVENT RECOVERY OF DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL,
                SPECIAL, EXEMPLARY, AND PUNITIVE DAMAGES (EVEN IF NOTABLE, ITS LICENSORS OR CONTENT
                PROVIDERS HAVE BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES). SUCH LIMITATION OF
                LIABILITY SHALL APPLY WHETHER THE DAMAGES ARISE FROM USE OR MISUSE OF AND/OR
                RELIANCE ON THE NOTABLE PLATFORM, FROM INABILITY TO USE THE NOTABLE PLATFORM, OR
                FROM THE INTERRUPTION, SUSPENSION, OR TERMINATION OF THE NOTABLE PLATFORM (INCLUDING
                SUCH DAMAGES INCURRED BY THIRD PARTIES).
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                UNDER NO CIRCUMSTANCES SHALL NOTABLE, ITS LICENSORS OR CONTENT PROVIDERS BE HELD
                LIABLE FOR ANY DELAY OR FAILURE IN PERFORMANCE RESULTING DIRECTLY OR INDIRECTLY FROM
                ACTS OF NATURE, FORCES, OR CAUSES BEYOND ITS REASONABLE CONTROL, INCLUDING, WITHOUT
                LIMITATION, INTERNET FAILURES, EQUIPMENT FAILURES, OR ACTS OF GOD.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                IF, NOTWITHSTANDING THESE LIMITATIONS OF LIABILITY, NOTABLE IS DETERMINED BY A COURT
                OF COMPETENT JURISDICTION TO BE LIABLE TO YOU IN ANY WAY, IN NO EVENT SHALL
                NOTABLE&#39;S LIABILITY EXCEED THE FEES YOUR EMPLOYER HAS PAID TO NOTABLE DURING THE
                TWELVE-MONTH PERIOD IMMEDIATELY PRECEDING YOUR CLAIM. YOU AND NOTABLE AGREE THAT THE
                FOREGOING LIMITATION OF LIABILITY IS AN AGREED ALLOCATION OF RISK BETWEEN YOU AND
                NOTABLE. YOU ACKNOWLEDGE THAT ABSENT YOUR AGREEMENT TO THIS LIMITATION OF LIABILITY,
                NOTABLE WOULD NOT PROVIDE THE SERVICES TO YOU.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                In some jurisdictions, limitations of liability are not permitted. In such
                jurisdictions, the foregoing limitation may not apply to you.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  INDEMNITY.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You agree to defend, indemnify and hold Notable and its respective directors,
                officers, employees, stockholders and agents harmless against any losses, expenses,
                costs or damages (including Notable&#39;s reasonable attorneys&#39; fees, expert
                fees&#39; and other reasonable costs of litigation) in connection with, arising out
                of, resulting from or caused by (1) your provision of medical care or medical
                services to patients, (2) your material breach of these Terms, (3) your unauthorized
                or unlawful use of the Platform or the Content, (4) the unauthorized or unlawful use
                of the Platform by any other person using your Credentials, (5) infringement of any
                intellectual property or other right of any person or entity by you, (6) the nature
                and content of all Customer Data processed by the Platform, or (7) any third-party
                products or services purchased or obtained by you in connection with the Platform.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  COOPERATION WITH GOVERNMENT AUTHORITIES.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable will cooperate with local, state, federal, international and/or worldwide
                government authorities to protect the Platform, visitors, customers, Notable, its
                parents, subsidiaries, affiliates and their respective members, directors, officers,
                employees, stockholders and agents and operational providers, when Notable
                determines, in its discretion, that such cooperation is appropriate to prevent or
                remedy unauthorized use of the Services.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  LINKS TO OTHER MATERIALS.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                The Platform may include links to third-party sites. The linked sites are not
                necessarily under the control of Notable and Notable is not responsible for, nor
                does it certify the content of, any linked site or any link contained in a
                non-affiliated linked site. Notable reserves the right to terminate any link or
                linking program at any time. The selection or omission of links is not intended to
                endorse any particular company or product. If you decide to access any of the
                third-party sites linked through the Platform, you do so entirely at your own risk.
                Notable shall have the right to disable or remove any link that violates any rights
                of Notable or causes interruption or deterioration of the Platform.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  APPLICABLE LAWS.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable makes no representation that the Platform or Content are appropriate or
                available for use in any particular jurisdiction, and access to them from
                jurisdictions where their content is illegal is prohibited. Those who choose to
                access the Platform from other locations do so on their own initiative and are
                responsible for compliance with applicable local laws, as well as any applicable
                Notable Client policies. You may not use or export the Site or Services or any
                Content in violation of United States export laws or regulations. Any claim relating
                to the Platform or these Terms shall be governed by the internal substantive laws of
                the State of California.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  ENTIRE AGREEMENT.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                These Terms and the Enterprise Terms contain the entire agreement between you and
                Notable relating to the subject matter hereof, and supersede any other oral or
                written communications relating thereto. These Terms may not be amended or
                supplemented by (1) any email message, purchase order, or similar communication
                originated by you relating to the subject matter hereof, or (2) statements of any of
                Notable&#39;s employees. If we make material changes to these Terms, we will notify
                you of such changes by posting them on the Platform or by sending you an email or
                other notification, and we will indicate when such changes will become effective. By
                continuing to access or use our Platform after those revisions become effective, you
                agree to be bound by the revised Terms.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  ASSIGNMENT.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You may not assign your rights under these Terms without Notable&#39;s prior written
                permission. Any attempt to assign your rights under these Terms without
                Notable&#39;s permission shall be void.
              </Text>
            </Text>
            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                You agree that your account is non-transferable and any rights to your username,
                password, or contents of your account terminate upon the termination of your
                employment or engagement with the Notable Client. Upon receipt of notice of
                termination by the Notable Client, your account may be terminated and all contents
                therein permanently deleted.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  WAIVER OF BREACH.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Any failure to enforce any term or provision of these Terms shall not be deemed a
                waiver of that or any other breach of that or any other term or provision. In
                addition, any failure to enforce any term or provision of these Terms shall not
                constitute a waiver of a future breach of that or any other term or provision of
                these Terms.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  NOTICE.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                Notable may deliver notice to you by means of electronic mail to the email address
                on record in Notable&#39;s account information, or by a general notice on the
                Platform, or by written communication delivered by first class U.S. mail to your
                address on record in Notable&#39;s account information. You may give notice to
                Notable at any time via electronic mail to legal@notablehealth.com or by letter
                delivered by first-class postage prepaid U.S. mail or overnight courier to the
                following address:
              </Text>
            </Text>
            <Text variant="body2" align="justify" sx={{ textIndent: (theme) => theme.spacing(4) }}>
              <Text variant="body2" component="span">
                Zealth, Inc., DBA Notable{' '}
              </Text>
            </Text>
            <Text variant="body2" align="justify" sx={{ textIndent: (theme) => theme.spacing(4) }}>
              <Text variant="body2" component="span">
                101 S Ellsworth Ave, Ste 600
              </Text>
            </Text>
            <Text variant="body2" align="justify" sx={{ textIndent: (theme) => theme.spacing(4) }}>
              <Text variant="body2" component="span">
                San Mateo, California 94401
              </Text>
            </Text>
            <Text variant="body2" align="justify" sx={{ textIndent: (theme) => theme.spacing(4) }}>
              <Text variant="body2" component="span">
                United States
              </Text>
            </Text>
            <Text variant="body2" align="justify" sx={{ textIndent: (theme) => theme.spacing(4) }}>
              <Text variant="body2" component="span">
                Attn: Legal Department
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  HEADINGS.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                The headings contained in these Terms are for reference purposes only and shall not
                affect in any way the meaning or interpretation of these Terms.
              </Text>
            </Text>
          </ListItem>
          <ListItem sx={{ display: 'list-item', textAlign: 'justify', paddingLeft: 0 }}>
            <ListItemText
              disableTypography
              primary={
                <Text
                  variant="body2"
                  bold
                  sx={{
                    textDecoration: 'underline',
                    verticalAlign: 'baseline',
                    textDecorationSkipInk: 'none',
                  }}
                >
                  INVALIDITY.
                </Text>
              }
              sx={{ display: 'inline-block' }}
            />

            <Text variant="body2" align="justify">
              <Text variant="body2" component="span">
                If any provision of these Terms shall be held, be deemed, or shall in fact be,
                invalid, inoperative or unenforceable as applied to any particular case or
                circumstance because of the conflicts of any provision with any law, regulation,
                ordinance or for any other reason, the provision or provisions in question shall not
                be invalid, inoperative or unenforceable in any other case or circumstance, nor
                shall any other provision or provisions herein contained thereby be or become
                invalid, inoperative or unenforceable and such provision shall be reformed so that
                it would be valid, operative and enforceable to the maximum extent permitted in such
                circumstances.
              </Text>
            </Text>
          </ListItem>
        </List>
      </div>
    </div>
  );
}
